// import Encoding from 'encoding-japanese'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

function s2ab (s) {
  if (typeof ArrayBuffer !== 'undefined') {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  } else {
    let buf = new Array(s.length);
    for (let i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
}

function downloadExl (data, exportedFilename, opts) {
  const wb = { SheetNames: ['Sheet1'], Sheets: {}, Props: {} };
  wb.Sheets['Sheet1'] = XLSX.utils.aoa_to_sheet(data);//通过json_to_sheet转成单页(Sheet)数据
  FileSaver.saveAs(new Blob([s2ab(XLSX.write(wb, opts))], { type: "application/octet-stream" }), exportedFilename + '_' + new Date().format('yyyyMMddhhmmss') + '.' + (opts.bookType));
}

function exportTable (opts) {
  return function (data, headers, showHeaders, fileName, isNative) {
    console.log(data)
    console.log(headers)
    data = !isNative ? data.map(item => {
      return headers.reduce((r, h, idx) => {
        r[idx] = item[h]
        return r
      }, [])
    }) : data

    if (showHeaders) {
      data.unshift(showHeaders)
    }

    downloadExl(data, fileName || 'export', opts)

  }
}

//对外暴露的方法只有一个exportTable,
//如果导出为csv,则 参数 booktype 为 csv
//如果导出为excel, 则参数 booktype 为 xlsx
export default {
  install (Vue) {
    Vue.prototype.$exportTable = exportTable({ bookType: 'xlsx', bookSST: false, type: 'binary' })
  }
}